export default __webpack_public_path__ + "static/154-min-min-697c4607e72c30ce9ec6165854f4c313.jpg";